var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancialClarity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02-Financial_Plan",
    "data-name": "02-Financial Plan"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#eee",
    height: 47,
    rx: 4,
    width: 38,
    x: 5,
    y: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 7a4 4 0 0 0 -8 0h-4a2 2 0 0 0 -2 2v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a2 2 0 0 0 -2-2z",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 13v39a3.9989 3.9989 0 0 1 -4 4h-30a3.9989 3.9989 0 0 1 -4-4v-3a3.9989 3.9989 0 0 0 4 4h25a3.9989 3.9989 0 0 0 4-4v-36a3.9989 3.9989 0 0 0 -4-4h5a3.9989 3.9989 0 0 1 4 4z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 3.3a3.7556 3.7556 0 0 1 1.5-.3 3.9989 3.9989 0 0 1 4 4h-3a3.9777 3.9777 0 0 0 -2.5-3.7z",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 9v3a2.0059 2.0059 0 0 1 -2 2h-16a2.0059 2.0059 0 0 1 -2-2v-3a2.0146 2.0146 0 0 0 2 2h13a2.0059 2.0059 0 0 0 2-2 2.0146 2.0146 0 0 0 -2-2h3a2.0059 2.0059 0 0 1 2 2z",
    fill: "#e53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 20h6v6h-6z",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 32h6v6h-6z",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 44h6v6h-6z",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 20v6h-6v-3a3 3 0 0 0 3-3z",
    fill: "#ffa726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 32v6h-6v-3a3 3 0 0 0 3-3z",
    fill: "#ffa726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17 44v6h-6v-3a3 3 0 0 0 3-3z",
    fill: "#ffa726"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#757575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37 21h-15a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 27h-15a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 33h-9a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 39h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 45h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 51h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 46,
    fill: "#ffd54f",
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 46a15.0055 15.0055 0 0 1 -15 15 14.6 14.6 0 0 1 -2-.14 14.9931 14.9931 0 0 0 0-29.72 14.6 14.6 0 0 1 2-.14 15.0055 15.0055 0 0 1 15 15z",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 46,
    fill: "#ffb74d",
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 56.82a11 11 0 1 1 0-21.64 11.004 11.004 0 0 0 0 21.64z",
    fill: "#ffa726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.5 45h-1a1.5 1.5 0 0 1 0-3h3.5a1 1 0 0 0 0-2h-2v-1a1 1 0 0 0 -2 0v1.05a3.4922 3.4922 0 0 0 .5 6.95h1a1.5 1.5 0 0 1 0 3h-3.5a1 1 0 0 0 0 2h2v1a1 1 0 0 0 2 0v-1.05a3.4922 3.4922 0 0 0 -.5-6.95z",
    fill: "#eee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialClarity);
export default __webpack_public_path__ + "static/media/financial-clarity.bfd2f37dae49f298068729c42e3c9b46.svg";
export { ForwardRef as ReactComponent };